<template>
  <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
    <feather-icon
      icon="FileIcon"
      svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
      @click="exportRecord()"
    />
    <!--<feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord" />-->
    
  </div>
</template>

<script>
import moment from "moment-timezone";
import ls from "@/common/localStorage";
export default {
  name: "CellRendererExport",
  watch: {
  },
  methods: {
    exportRecord() {
      let vm = this;
      this.$vs.loading();
      let Session_Event_TZ = ls.getSessionValueByKey("Session_Event_TZ");
      this.$store
        .dispatch("exhibitorManagement/getBoothStats", {
          exhibitorId: this.params.data.ExhibitorId
        })
        .then((row) => {
          this.$vs.loading.close();
          if (row) {
            var datarow = [];
            /*datarow.push("Booth Name");
            datarow.push("Data Exported in");
            datarow.push("Total Booth Views");
            datarow.push("Total Resource Views");
            datarow.push("Total Video Views");
            datarow.push("Total Business Card Exchanges");
            datarow.push("Total Profile Views");
            datarow.push("Total Roundtable Visits");
            datarow.push("Total Chat Messages");
            datarow.push("Total Rep Video Calls");*/
            var AttendeeData = [];
            //AttendeeData.push(datarow);
              //datarow = [];
              datarow.push("Booth Name");
              datarow.push('"' + vm.params.data.Name + '"');
              AttendeeData.push(datarow); datarow = [];
              datarow.push("Data Exported in");
              datarow.push('"' + moment().tz(Session_Event_TZ).format('MMM DD, YYYY HH:mm A') + ` (${Session_Event_TZ})` + '"');             
              AttendeeData.push(datarow); datarow = [];
              datarow.push("Total Booth Views");   
              datarow.push('"' + row.totBoothViews ? row.totBoothViews : 0 + '"');
              AttendeeData.push(datarow); datarow = [];
              datarow.push("Total Resource Views");
              datarow.push('"' + row.totResourceViews ? row.totResourceViews : 0 + '"');
              AttendeeData.push(datarow); datarow = [];
              datarow.push("Total Video Views");
              datarow.push('"' + row.totVideoViews ? row.totVideoViews : 0 + '"');  
              AttendeeData.push(datarow); datarow = [];
              datarow.push("Total Business Card Exchanges");            
              datarow.push('"' + row.totBusinessCardExcahnges ? row.totBusinessCardExcahnges : 0 + '"');
              AttendeeData.push(datarow); datarow = [];
              datarow.push("Total Profile Views");
              datarow.push('"' + row.totProfileViews ? row.totProfileViews : 0 + '"');
              AttendeeData.push(datarow); datarow = [];
              datarow.push("Total Roundtable Visits");
              datarow.push('"' + row.totRoundtableVisits ? row.totRoundtableVisits : 0 + '"');  
              AttendeeData.push(datarow); datarow = [];
              datarow.push("Total Chat Messages");            
              datarow.push('"' + row.totChatMessages ? row.totChatMessages : 0 + '"');   
              AttendeeData.push(datarow); datarow = [];
              datarow.push("Total Rep Video Calls");           
              datarow.push('"' + row.totRepVideoCalls ? row.totRepVideoCalls : 0 + '"');              
              AttendeeData.push(datarow);
              
              if(row.resourceDownloads && row.resourceDownloads.length){
                AttendeeData.push([]);
                datarow = [];
                datarow.push("Resource Name");
                datarow.push("No of views");
                AttendeeData.push(datarow);

                row.resourceDownloads.filter(u=>{ 
                  datarow = [];                 
                  datarow.push('"' + u.resourceName + '"');
                  datarow.push('"' + u.downloadCount ? u.downloadCount : 0 + '"');
                  AttendeeData.push(datarow);
                })
              }
              
              if(row.userList && row.userList.length){
                AttendeeData.push([]);
                datarow = [];
                datarow.push("First Name");
                datarow.push("Last Name");
                datarow.push("Email");
                datarow.push("Registration Type");
                datarow.push("Company Name");
                datarow.push("Job Title");
                datarow.push("City");
                datarow.push("State");
                datarow.push("ZIP Code");
                datarow.push("Country Code");
                datarow.push("Phone Number");
                datarow.push("Original Registration Date");
                datarow.push("Date of First Login");
                datarow.push("Date of Last Login");
                datarow.push("Business Card Exchanges");
                datarow.push("Total Rep Video Calls");
                datarow.push("Total Company Profile Views");
                datarow.push("Total Video Views");
                datarow.push("Total Resource Downloads");
                datarow.push("Chat Room Messages");
                datarow.push("Total Roundtable Visits");
                AttendeeData.push(datarow);

                row.userList.filter(u=>{ 
                  datarow = [];                 
                  datarow.push('"' + u.firstName + '"');
                  datarow.push('"' + u.lasttName + '"');
                  datarow.push('"' + u.email + '"');
                  datarow.push('"' + u.registrationType ? u.registrationType : 'NA' + '"');
                  datarow.push('"' + u.company + '"');
                  datarow.push('"' + u.jobTitle + '"');
                  datarow.push('"' + u.city + '"');
                  datarow.push('"' + u.state + '"');
                  datarow.push('"' + u.zip + '"');
                  datarow.push('"' + u.countryCode + '"');
                  datarow.push('"' + u.phone + '"');
                  datarow.push('"' + moment.utc(u.regisreredOnUTC).tz(Session_Event_TZ).format('MMM DD, YYYY HH:mm A') + '"');
                  datarow.push('"' + moment.utc(u.firstLoginDtmUTC).tz(Session_Event_TZ).format('MMM DD, YYYY HH:mm A') + '"');
                  datarow.push('"' + moment.utc(u.lastLoginDtmUTC).tz(Session_Event_TZ).format('MMM DD, YYYY HH:mm A') + '"');
                  datarow.push('"' + u.hasExchangedBusinessCard ? u.hasExchangedBusinessCard : 0 + '"');
                  datarow.push('"' + u.totRepVideoCalls ? u.totRepVideoCalls : 0 + '"');
                  datarow.push('"' + u.totProfileViews ? u.totProfileViews : 0 + '"');
                  datarow.push('"' + u.totVideoViews ? u.totVideoViews : 0 + '"');
                  datarow.push('"' + u.totResourceViews ? u.totResourceViews : 0 + '"');
                  datarow.push('"' + u.totChatMessages ? u.totChatMessages : 0 + '"');
                  datarow.push('"' + u.totRoundtableVisits ? u.totRoundtableVisits : 0 + '"');
                  AttendeeData.push(datarow);
                })
              }      

            let csvContent = "data:text/csv;charset=utf-8,";
            var dt = new Date().toISOString().slice(0, 10);
            AttendeeData.forEach(function (rowArray) {
              let row = rowArray.join(",");
              csvContent += row + "\r\n";
            });
            var filename = vm.params.data.Name+"_boothStatsExport_" + "_" + dt + ".csv";
            var encodedUri = encodeURI(csvContent);
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            //link.setAttribute("id", "Participance_RT_" + row.TableId);
            link.setAttribute("download", filename);
            document.body.appendChild(link); // Required for FF

            link.click();
            //---------------------------------------------------------------
          } else {
            this.$vs.dialog({
              type: "alert",
              color: "warning",
              title: "Download Report",
              text: "No data to export. ",
              //accept: this.deleteRecord,
              acceptText: "OK",
            });
          }
        })
        .catch(err => {
          this.$vs.loading.close();
        });
    },
  }
};
</script>
